import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { ColumnPropTypes } from "./props";

// UI
import Container from "./components/container";
import Thead from "./components/table/thead";
import Tbody from "./components/table/tbody";
import Tfoot from "./components/table/tfoot";
import EmptyBody from "./components/table/emptyBody";
import LoadingBody from "./components/table/loading/loadingBody";
import LoadingGradient from "./components/table/loading/loadingGradient";

class Table extends React.Component {
  render() {
    let {
      columns,
      data,
      loading,
      isResponsive,
      tableContainerClassName,
      tableClassName,
      size,
      tbody,
      tfoot,
      onClickRow,
      children
    } = this.props;

    const tableClasses = classNames(
      "table",
      {
        [`table-size-${size}`]: size
      },
      tableClassName
    );

    return (
      <Container
        isResponsive={isResponsive}
        loading={loading}
        className={tableContainerClassName}
      >
        <table className={tableClasses}>
          <Thead columns={columns} />

          {loading ? (
            !data || !data.length ? (
              <LoadingBody columns={columns} />
            ) : (
              <Tbody columns={columns} data={data} />
            )
          ) : data && data.length ? (
            <Tbody
              columns={columns}
              data={data}
              onClickRow={onClickRow}
              loading={loading}
            />
          ) : children ? (
            children
          ) : tbody ? (
            <tbody>{tbody}</tbody>
          ) : (
            <EmptyBody countColumns={columns.length} />
          )}

          {loading || (data && data.length) ? (
            tfoot ? (
              tfoot
            ) : (
              <Tfoot columns={columns} data={data} loading={loading} />
            )
          ) : null}
        </table>

        <LoadingGradient loading={loading} />
      </Container>
    );
  }
}

Table.defaultProps = {
  columns: [],
  data: [],
  footer: [],
  isResponsive: true,
  tableContainerClassName: null,
  tableClassName: null,
  size: null,
  loading: false,
  tbody: null,
  tfoot: null,
  onClickRow: () => {},
  children: null
};

Table.propTypes = {
  // Колонки
  columns: PropTypes.arrayOf(ColumnPropTypes),
  // Данные
  data: PropTypes.array,
  // Колонки footer
  footer: PropTypes.arrayOf(ColumnPropTypes),
  // Скрол x?
  isResponsive: PropTypes.bool,
  // Класс контейнера
  tableContainerClassName: PropTypes.string,
  // Класс таблицы
  tableClassName: PropTypes.string,
  // Размер
  size: PropTypes.oneOf(["m", "l", "xl"]),
  // Загрузка?
  loading: PropTypes.bool,
  // Тело
  tbody: PropTypes.node,
  // Футер
  tfoot: PropTypes.node,
  // По нажатию на tr
  onClickRow: PropTypes.func,
  // Ребёнок
  children: PropTypes.node
};

export default Table;
